import { Box } from '@mui/material';
import { NotificationsSnackbar } from './snackbar/NotificationsSnackbar';
import { Sidebar } from './sidebar/Sidebar';
import { useUser } from '@/contexts/user/UserContext';
import { Consents } from './consent/Consents';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { setCompanyIdInLocalStorageWithoutReload } from '@/services/companyService';
import { useAppDispatch } from '@/lib/hooks';
import { getAdminCompanies } from '@/lib/slices/paymentsSlice';
import { UserRoles } from '@/models/company';
import { TransactionDetailDialog } from '@/pages/history/TransactionDetailDialog';
import { useQueryClient } from '@tanstack/react-query';
import { useConsentStore } from '@/stores/consentStore';

type PageLayoutProps = {
    children: JSX.Element;
};

export const PageLayout = (props: PageLayoutProps) => {
    const { company, user, reloadUserData } = useUser();
    const { isPostponed } = useConsentStore();

    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const queryClient = useQueryClient();

    // Extract changeCompanyId from URL
    const params = new URLSearchParams(location.search);
    const changeCompanyId = params.get('changeCompanyId');

    useEffect(() => {
        if (changeCompanyId) {
            setCompanyIdInLocalStorageWithoutReload(changeCompanyId);
            const params = new URLSearchParams(location.search);
            params.delete('changeCompanyId');
            queryClient.removeQueries();
            reloadUserData();
            dispatch(getAdminCompanies());
            navigate(`${location.pathname}?${params.toString()}`, {
                replace: true
            });
        }
    }, [changeCompanyId]);

    return (
        <Box sx={{ display: 'flex' }}>
            <Sidebar />
            <Box
                component="main"
                sx={{ flexGrow: 1, margin: '20px', marginTop: '40px' }}
            >
                {(company.requiredConsentsAccepted &&
                    !(
                        company.optionalConsentsAvailable &&
                        !isPostponed(company.companyId)
                    )) ||
                user.role == UserRoles.SuperAdmin ||
                user.role == UserRoles.Manager ? (
                    <>{props.children}</>
                ) : (
                    <Consents />
                )}
            </Box>
            <NotificationsSnackbar />
            <TransactionDetailDialog />
        </Box>
    );
};
